import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { notificationsReducer } from "./notifications.reducer";
import { NotificationsEffects } from "./notifications.effects";

@NgModule({
  imports: [StoreModule.forFeature("NOTIFICATIONS_FEATURE", notificationsReducer), EffectsModule.forFeature([NotificationsEffects])],
})
export class StoreNotificationsModule {}

